export default {
  searchForm: document.querySelector('.search-form'),
  searchFormInput: document.querySelector('.search-form__input'),
  favoriteCityStar: document.querySelector('.search-form__favorite-city'),
  favoriteCityList: document.querySelector('.favorite-list'),
  containerWeatherToday: document.querySelector('.weather-today'),
  dayOfWeek: document.querySelector('.timer-date__dayOfWeek'),
  dayOfMonth: document.querySelector('.timer-date__dayOfMonth'),
  monthSpan: document.querySelector('.month'),
  timeSpan: document.querySelector('.time'),
  currentWeatherIcon: document.querySelector('.weather-today-icon'),
  cityName: document.querySelector('.current-name-city'),
  tempToday: document.querySelector('.current-temperature-today'),
  tempTodayMin: document.querySelector('.today-min'),
  tempTodayMax: document.querySelector('.today-max'),
  weatherContainer: document.querySelector('.weather-5day-container'),
  onClickBtnOneDay: document.querySelector('.weather-one-day'),
  onClickBtnFiveDay: document.querySelector('.weather-5days'),
  preloader: document.querySelector('.preloader-con'),
  sunrise: document.querySelector('.sunrise__time'),
  sunset: document.querySelector('.sunset__time'),
  backgroundRef: document.querySelector('.background-image'),
  timerContainer: document.querySelector('.timer-date'),
  quoteText: document.querySelector('.quote__text'),
  quoteAuthor: document.querySelector('.quote__author'),
  blickQuote: document.querySelector('.quote__block'),
  positionForBtn: document.querySelector('.buttons-today-5days'),
};
